<template>
  <div class="hero-video">
    <!-- Dev placeholder: shown when UID is fake (no real Cloudflare account yet) -->
    <template v-if="isFakeUid">
      <img
        v-if="item.image"
        :src="`${item.image}?width=1280`"
        class="hero-video__video"
        :alt="item.imageAltText || ''">
      <div class="hero-cloudflare-dev-badge">
        ▶ Cloudflare Stream (dev mode — fake UID)
      </div>
    </template>

    <!-- Real Cloudflare Stream player -->
    <div v-else ref="streamContainer" class="hero-video__video hero-video__video--stream"></div>

    <button
      v-show="paused && !isFakeUid"
      class="hero-video__action"
      :aria-label="tStatic('pressToPlayVideo')"
      @click="toggleVideo(true)"
      @mouseenter="playIcon = 'play-darker'"
      @mouseleave="playIcon = 'play'">
      <oie-use-svg :svg="playIcon" :height="size" :width="size"></oie-use-svg>
    </button>

    <button
      v-show="playing && !isFakeUid"
      class="hero-video__action"
      :aria-label="tStatic('pressToPauseVideo')"
      @click="toggleVideo(false)"
      @mouseenter="pauseIcon = 'pause-darker'"
      @mouseleave="pauseIcon = 'pause'">
      <oie-use-svg :svg="pauseIcon" :height="size" :width="size"></oie-use-svg>
    </button>
  </div>
</template>

<script>
import { createCloudflarePlayer } from '@/core/video-service'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      player: null,
      playing: true,
      playIcon: 'play',
      pauseIcon: 'pause'
    }
  },
  computed: {
    isFakeUid() { return this.item.cloudflareVideoId && this.item.cloudflareVideoId.startsWith('fake-') },
    // Accessible name for the Stream iframe, which cannot carry an alt attribute.
    mediaLabel() { return this.item.imageAltText || this.item.title || '' },
    paused() { return !this.playing },
    size() { return this.mq('to-large') ? 30 : 40 }
  },
  async mounted() {
    if (this.isFakeUid) return

    this.player = await createCloudflarePlayer(
      this.$refs.streamContainer,
      this.item.cloudflareVideoId,
      {
        autoplay: true,
        muted: true,
        fill: true,
        title: this.mediaLabel,
        maxLoops: 2,
        onLoopsComplete: () => { this.playing = false }
      }
    )

    this.player.play()
  },
  methods: {
    toggleVideo(play) {
      this.playing = play
      play ? this.player.play() : this.player.pause()
    }
  }
}
</script>

<style lang="scss">
.hero-video__video--stream {
  overflow: hidden;
}

.hero-cloudflare-dev-badge {
  position: absolute;
  bottom: measure(half);
  left: measure(half);
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  pointer-events: none;
  z-index: 2;
}
</style>
